// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"d20bf53d","481":"5570a2f8","590":"fd273b5d","840":"0bdff00e","844":"f93b2a02"}[chunkId] + ".chunk.js";
};